'use client';

import React from 'react';
import clsx from 'clsx';
import { Button, Icon } from '@/components/core';
import { UIComponent } from '@/components/core/components';
import { useUser } from '@/components/context/user';
import useLike from '@/components/core/hooks/use-like';
import Like from '@/components/core/components/molecules/like';
import { useAddCollectionContext } from '@/components/context/add-to-collection';
import useBookmark from '@/components/core/hooks/use-bookmark';
import { useLocalizedLinks } from '@/components/core/hooks';
import * as styles from './feed-sidebar.styles';
import { useFeed } from '../context/context';
import { useDownloadApp } from '../../../download-app-modal/download-app-modal';

const FeedSideBar: UIComponent = ({ children, ...props }) => {
  const { product: mainProduct, recommendation } = useFeed(props);
  const [likes, like, likeClassname] = useLike(recommendation);
  const product = useBookmark(mainProduct);
  const links = useLocalizedLinks();
  const { addToCollection } = useAddCollectionContext();
  const { isLogged, user } = useUser();
  const downloadApp = useDownloadApp();

  if (!product) {
    return null;
  }

  const share = (evt) => {
    evt.preventDefault();
    evt.stopPropagation();
    navigator.share({
      title: product.name,
      url: links.product(product),
    });
  };

  const isMine = isLogged && user?.id === recommendation?.user.id;

  return (
    <aside className={clsx(styles.sidebar)}>
      {children || (
        <>
          <Button variant="tertiary" onClick={share}>
            <Icon name="share" />
          </Button>
          {recommendation && (
            <div className={clsx('flex flex-col items-center', { hidden: recommendation?.user.id === user?.id })}>
              <Button
                onClick={(evt) => {
                  evt.preventDefault();
                  evt.stopPropagation();
                  if (!isLogged) {
                    downloadApp('like');
                    return;
                  }
                  like();
                }}
                variant="tertiary"
              >
                <Like className={likeClassname} />
              </Button>
              {likes > 0 && <span className={styles.btnsText}>{likes}</span>}
            </div>
          )}

          {isMine && (
            <Button
              variant="tertiary"
              onClick={() => {
                //
              }}
            >
              <Icon name="analytics" />
            </Button>
          )}
          {!isMine && (
            <Button
              variant="tertiary"
              onClick={(evt) => {
                evt.preventDefault();
                evt.stopPropagation();
                if (isLogged) {
                  addToCollection(product);
                  return;
                }
                downloadApp('bookmark');
              }}
            >
              <Icon name={product.isSaved ? 'bookmark-fill' : 'bookmark'} />
            </Button>
          )}
        </>
      )}
    </aside>
  );
};

export default FeedSideBar;
